import {
  Dialog,
  styled,
  alpha,
  Stack,
  Typography,
  Divider,
  Button,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/DeleteOutline';

export const StyledDeleteIcon = styled(DeleteIcon)(({ theme }) => ({
  color: theme.palette.grey[500],
  cursor: 'pointer',
}));

export const StyledDialogContainer = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    width: theme.spacing(48),
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    background: theme.palette.grey[800],
  },
  '& .MuiBackdrop-root': {
    background: alpha(theme.palette.common.white, 0.25),
  },
}));

export const StyledHeaderContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  width: '100%',
  marginBottom: theme.spacing(1),
}));

export const StyledTitle = styled(Typography)(() => ({
  fontSize: 16,
  fontWeight: 700,
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

export const StyledCTAContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(1),
}));

export const StyledCancelButton = styled(Button)(({ theme }) => ({
  color: theme.palette.grey[400],
  marginRight: theme.spacing(2),
  '&:hover': {
    color: theme.palette.grey[100],
  },
}));
